const MILLISECONDS_PER_YEAR = 3.154e10;

const getAge = (birthday: string | number | Date) => {
  const now = new Date();
  const diff = Number(now) - Number(new Date(birthday));

  return Math.floor(diff / MILLISECONDS_PER_YEAR);
};

export { getAge };
